<template>
  <div>
    <vue-html2pdf
        :filename="fileName"
        :pdf-quality="2"
        :paginate-elements-by-height="1400"
        pdf-format="a4"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div v-if="charityInfo && donation" id="invoice">
          <div class="row">
            <div class="col-lg-6">
              <div v-if="charityInfo.logo_transparent" id="logo">
                <img :src="charityInfo.logo_transparent" style="max-width: 100px; max-height: 50px"  alt="">
              </div>
            </div>
            <div class="col-lg-6">
              <p id="details"><strong>Date:</strong> {{ donation.created_at | dateFormat("MM/DD/YY") }} <br></p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <h2>Donation Receipt</h2>
              <p style="padding-bottom: 0;">Thanks for your donation to <strong>{{donation.campaign_name}}</strong></p>
              <div v-if="donation.metadata && donation.metadata.honor">
                <p style="margin-top: 20px;margin-bottom: -40px;">In Honor of
                  <strong>{{ donation.metadata.honor.name }}</strong>
                </p>
                <p style="font-style: italic;">"{{ donation.metadata.honor.message }}"<br>
                  - {{ donation.metadata.honor.from }}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <strong class="margin-bottom-5">{{ charityInfo.charity_name }}</strong>
              <p v-if="charityInfo.address">
                {{ charityInfo.address.line_1 }} {{ charityInfo.address.line_2 }}<br>
                {{ charityInfo.address.city }}<span
                  v-if="charityInfo.address.city && charityInfo.address.state">,</span>
                {{ charityInfo.address.state }} {{ charityInfo.address.zip }}
              </p>
              <p v-else></p>
            </div>

            <div class="col-lg-6">
              <div>
                <strong class="margin-bottom-5">{{ donation.first_name }} {{ donation.last_name }}</strong>
                <div v-if="donation.email">{{ donation.email }}</div>
              </div>

              <p v-if="donation.address">
                {{ donation.address.street_number }} {{ donation.address.route }}<br>
                <span style="display: block" v-if="donation.address.premise">{{ donation.address.premise }}</span>
                {{ donation.address.locality }}, {{ donation.address.administrative_area_level_1 }}
                {{ donation.address.postal_code }}<br>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <table class="margin-top-20">
                <tr>
                  <th>Donation Type</th>
                  <th style="width: 20%;">Amount</th>
                  <th style="width: 20%;">Fees Covered</th>
                  <th style="width: 20%;">Total</th>
                </tr>
                <tr>
                  <td>{{
                      donation.type.replace('custom', 'One-Time')
                          .replace('recurring', 'Monthly')
                          .replace('roundup', 'Round-Up')
                    }} Donation
                  </td>
                  <td>${{ donation.intended_amount / 100 | formatMoney(2) }}</td>
                  <td>${{ donation.covered_fee / 100 | formatMoney(2) }}</td>
                  <td>${{ donation.amount / 100 | formatMoney(2) }}</td>
                </tr>
              </table>
            </div>
            <div class="col-lg-6">
              <table id="totals">
                <tr>
                  <th>Total Donation Amount</th>
                  <th v-bind:style="{ 'border-color': charityInfo.primary_color }"
                      width="20px"
                  ><span>${{ donation.amount / 100 | formatMoney(2) }}</span></th>
                </tr>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <ul id="footer">
                <li>⚡ Powered by <strong>Harness</strong></li>
                <li>{{ charityInfo.charity_name }}</li>
                <li v-if="charityInfo.ein">
                  <b>EIN:</b> {{ charityInfo.ein.replace(/(\d{2})-?(\d+)/, '$1-$2') }}
                </li>
              </ul>
              <p>No goods or services were provided in exchange for your contribution</p></div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import {getAllCampaigns} from "@/utils/api";
const moment = require('moment');

export default {
  name: 'Receipt',
  components: {
    VueHtml2pdf
  },
  data() {
    return {
      charityInfo: null,
      donation: null,
    }
  },
  methods: {
    async generatePdf(donation, charityInfo) {
      if (donation && charityInfo) {
        this.donation = donation;

        if (this.donation.campaign_id) {
          const activeCampaignId = parseInt(this.donation.campaign_id);
          const campaigns = await getAllCampaigns(true);

          const campaign = campaigns.reduce((res, cmp) => parseInt(cmp.id) === activeCampaignId ? cmp : res, null);
          this.donation.campaign_name = campaign ? campaign.name : 'Area of Greatest Need';
        }

        this.charityInfo = charityInfo;

        this.$nextTick(() => {
          this.$refs.html2Pdf.generatePdf()
        });
      }
    },
  },
  computed: {
    fileName() {
      if (this.donation) {
        return `Donation Receipt - ${this.donation.first_name} ${this.donation.last_name} `
            + moment(this.donation.created_at).format("MM-DD-YY");
      }

      return `Donation Receipt`;
    }
  }
}


</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Nunito:300,400,600,700,800&subset=latin-ext');
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i');

#invoice {
  font-family: Open Sans, Nunito, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
  text-transform: none;
  background: white;
  font-size: 100%;
  color: #666;
  font-weight: 300;
  line-height: 28px;
  padding: 60px;
  margin: 0 auto;
  border-radius: 4px;


  strong {
    font-weight: 600;
    color: #333;
    display: inline-block;
  }

  h1,
  h2,
  h3 {
    font-weight: 300;
    color: #333;
    clear: both;
    margin: 0;
  }

  h2 {
    font-size: 36px;
    line-height: 1;
    margin: 15px 0 10px 0;
    font-weight: 600;
  }

  p {
    margin: 0;
    padding-bottom: 40px;
    clear: both;
    line-height: 28px;
  }

  #logo {
    display: block;
    height: auto;
    vertical-align: baseline;
    padding-right: 0;
    margin-right: 0;
  }

  #details {
    text-align: right;
  }

  table {
    width: 100%;
    margin: 0 0 30px;
    padding: 1px 0;
    border-spacing: 0;
    border-bottom: 1px solid #ddd;
  }

  th,
  td {
    padding: 15px 0;
    text-align: left;
  }

  th {
    font-weight: 700;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    color: #333;
  }

  th:last-child,
  td:last-child {
    text-align: right;
  }

  th span {
    position: relative;
    display: inline-block;
    height: 100%;
  }

  th span::after {
    content: '';
    width: 100%;
    bottom: -16px;
    position: absolute;
    right: 0;
    //border-bottom: 1px solid #ffffff;
  }

  #footer {
    width: 100%;
    background-color: transparent;
    color: #666;
    border-top: 1px solid #ddd;
    margin: 60px 0 0 0;
    padding: 20px 0 0 0;
    list-style: none;
    font-size: 15px;
  }

  #footer li {
    display: inline-block;
    padding: 0 20px;
    border-right: 1px solid #ddd;
    line-height: 11px;
  }

  #footer li:first-child {
    padding-left: 0;
  }

  #footer li:last-child {
    border: none;
  }

  #footer li span {
    color: #ffffff;
  }

  strong,
  th,
  h1,
  h2,
  h3 {
    color: #111;
  }

  table,
  th,
  #footer,
  #footer li {
    border-color: #bbb;
  }

}
</style>
